import {createSelector} from 'reselect';

import {getPersonName} from '../../App/selectors';

export const selectName = createSelector([getPersonName], name => name);
